import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRocket } from "@fortawesome/free-solid-svg-icons";

const ComingSoon = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80vh",
                width: "100%",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "1rem",
                    padding: "2.5rem 4rem",
                    background: "linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)",
                    borderRadius: "1rem",
                    boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
                    userSelect: "none",
                }}
            >
                <FontAwesomeIcon
                    icon={faRocket}
                    style={{
                        fontSize: "3.5rem",
                        color: "#C8511B",
                        transform: "rotate(-45deg)",
                        filter: "drop-shadow(0 2px 6px rgba(200,81,27,0.4))",
                    }}
                />
                <div
                    style={{
                        fontSize: "2rem",
                        fontWeight: 700,
                        letterSpacing: "0.12em",
                        color: "#333",
                    }}
                >
                    Coming Soon
                </div>
                <div
                    style={{
                        fontSize: "0.95rem",
                        color: "#888",
                        letterSpacing: "0.04em",
                    }}
                >
                    Working on something great. Stay tuned!
                </div>
            </div>
        </div>
    );
};

export default ComingSoon;
